import { render, staticRenderFns } from "./UserEditRolesPermissionsTab.vue?vue&type=template&id=364c6aa0"
import script from "./UserEditRolesPermissionsTab.vue?vue&type=script&lang=ts"
export * from "./UserEditRolesPermissionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports